import t from 'react-translate';
import { css } from '@emotion/react';
import { gray4 } from 'styles/global_defaults/colors';

const styles = css`
  &.headers {
    border-bottom: 1px solid ${gray4};
  }
`;

const ProgramLevelHeaders = () => {
  const headers = [
    t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.HEADERS.QUESTION(),
    t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.HEADERS.QUESTION_TYPE(),
    t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.HEADERS.REQUIRED(),
  ];

  return (
    <div css={styles} className='text-small semi-bold align-content-center headers'>
      {headers.map((header) => (
        <div key={header} className='cell'>
          {header}
        </div>
      ))}
      <span />
    </div>
  );
};

export default ProgramLevelHeaders;
